export default __webpack_public_path__ + "static/creator-bundle-e4a8b2a2f963d696b0356a926953a962.png";